import AppLayout from '../../layout/AppLayout';
import AppAboutIntro from '../AppAboutIntro/AppAboutIntro';
import AppStaticChart from '../AppStaticChart/AppStaticChart';
import AppBanner from '../AppBanner/AppBanner';
import AppClients from '../AppClients/AppClients';
import AboutUs from '../AboutUs';
import AppHead from '../AppHead';

export default function About({ page }) {
  const { title, values, desc, language_urls, meta } = page.data;

  return (
    <AppLayout localesUrls={language_urls}>
      <AppHead
        language_urls={language_urls}
        metaTitle={meta?.title || title}
        metaDescription={meta?.description}
      />
      <AppAboutIntro title={title} desc={desc} />
      <AppStaticChart cahrtItems={values} />
      <AboutUs />
      <AppBanner />
      <AppClients />
    </AppLayout>
  );
}
